import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Flipper, Flipped } from 'react-flip-toolkit'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {},
  header: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    marginBottom: theme.spacing(4),
    paddingTop: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.background.medium}`,
  },
  inkbar: {
    height: 2,
    backgroundColor: theme.palette.primary.main,
  },
  label: {
    cursor: 'pointer',
    marginRight: theme.spacing(6),
  },
  activeLabel: {
    color: theme.palette.primary.main,
  },
  labelName: {
    marginBottom: theme.spacing(2),
  },
})
class InkyCarousel extends React.Component {
  state = {
    activeIndex: 0,
  };

  setActiveIndex = (activeIndex) => {
    this.setState({ activeIndex })
  };

  render() {
    const { activeIndex } = this.state
    const { classes, children } = this.props

    return (
      <Flipper flipKey={activeIndex}>
        <div className={classes.root}>
          <header className={classes.header}>
            {children.map((item, index) => {
              const isActive = index === activeIndex
              return (
                <div
                  key={`inky-${index}`}
                  className={classNames(
                    classes.label,
                    isActive && classes.activeLabel
                  )}
                  onClick={() => this.setActiveIndex(index)}>
                  <Typography className={classes.labelName}>
                    {item.props.name}
                  </Typography>
                  {isActive && (
                    <Flipped flipId="inkbar">
                      <div className={classNames(classes.inkbar)} />
                    </Flipped>
                  )}
                </div>
              )
            })}
          </header>
          {children[activeIndex]}
        </div>
      </Flipper>
    )
  }
}

InkyCarousel.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object,
}

export default withStyles(styles)(InkyCarousel)



// WEBPACK FOOTER //
// ./src/components/organisms/InkyCarousel.js